<template>
  <v-row>
    <v-col
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.radioButton"
        :value.sync="isAnotherCourtSelected"
        :label="local.lawsuitDetails.HasPreviousRulingBeenIssuedInTheSameClaim"
        :items="previousRulingBeenIssuedInTheSameClaimItems"
        item-value="id"
        item-text="name"
        :disabled="disabled"
        validates="required"
        @change="isPreviousRulingBeenIssuedInTheSameClaim"
      ></naj-input>
    </v-col>
    <v-col
      v-if="isAnotherCourtSelected !== null"
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.selectbox"
        :label="local.lawsuitDetails.court"
        :value="courtId"
        :items="closestCourts"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        :validates="'required'"
        @change="updateCourtId"
      ></naj-input>
      <span class="user-attention">
        {{ local.lawsuitDetails.executionDescription }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return {
      closestCourts: [],
      previousRulingBeenIssuedInTheSameClaimItems: [{
        id: true,
        name: this.local.common.yes,
      }, {
        id: false,
        name: this.local.common.no,
      }],
      isAnotherCourtSelected: null,
    };
  },
  computed: { ...mapState({ caseData: state => state.lawsuitRequest.case }) },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'isAnotherCourtSelected': function (value) {
      this.$set(this.caseData, 'isAnotherCourtSelected', value);
    },
  },
  mounted() {
    this.isAnotherCourtSelected = this.caseData.isAnotherCourtSelected !== undefined ? this.caseData.isAnotherCourtSelected : null;
    this.handleGetCourts('mounted');
  },
  methods: {
    ...mapActions(['getPartiesClosestCourts', 'getExecutionCourts']),
    handelGetAvailableExecutionCourts() {
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      this.getExecutionCourts(caseClassificationId)
        .then((data) => {
          this.closestCourts = data.data.data;
          this.$emit('courtsRetrieved', this.closestCourts);
        });
    },
    handleGetPartiesClosestCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const accidentCityId = this.caseData.cityId || null;
      const disableLocationSpecializationRule = this.disableLocationSpecializationRule || this.disableLocationSpecializationRule || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          disableLocationSpecializationRule,
          accidentCityId,
          isRelatedToCorona,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    isPreviousRulingBeenIssuedInTheSameClaim() {
      this.updateCourtId(null);
      this.handleGetCourts('isPreviousRulingBeenIssuedInTheSameClaim');
    },
    handleGetCourts(invoker) {
      if (this.isAnotherCourtSelected)
        this.handelGetAvailableExecutionCourts();
      else
        this.handleGetPartiesClosestCourts(invoker);
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
